/**
 * Regole di formato per i dati che servono all'energia (T-15, INB-332): il
 * codice POD, senza il quale le misure non trovano il loro punto, e l'email,
 * con cui il socio riceve l'invito al portale. Valgono per il form e per l'API.
 */

/** Codice POD: `IT` + 3 cifre del distributore + `E` + 8 cifre (es. IT001E12345678). */
export const POD_PATTERN = /^IT\d{3}E\d{8}$/;

export const POD_FORMAT_ERROR =
	'Codice POD non valido: il formato è IT + 3 cifre + E + 8 cifre (es. IT001E12345678)';

/** Il codice POD come si salva: senza spazi, maiuscolo. */
export function normalizePod(value: string): string {
	return value.replace(/\s+/g, '').toUpperCase();
}

export function validatePod(value: string | null | undefined): string | undefined {
	const pod = normalizePod(value ?? '');
	if (!pod) return undefined;
	return POD_PATTERN.test(pod) ? undefined : POD_FORMAT_ERROR;
}

/** L'email come si salva: senza spazi ai bordi, minuscola. */
export function normalizeEmail(value: string): string {
	return value.trim().toLowerCase();
}

export function validateEmail(value: string | null | undefined): string | undefined {
	const email = normalizeEmail(value ?? '');
	if (!email) return undefined;
	return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? undefined : 'Indirizzo email non valido';
}
